// Represents the triple ballot-box present in the map and election pages
export class BallotBoxPanel {

    // This is the template for stuff 
    static template = `
<!--<button class = "flex-row r3-hidden md:r3-flex go_to_my_election" data-type="all">-->
<!--    <img src = "/assets/ballotBoxAe.webp?v=1">-->
<!--    <div class = "left-text">-->
<!--      <div class = "num" id="all_el_count"></div>-->
<!--      <div class = "light-gray election-label">All Positions-->
<!--&lt;!&ndash;      <span class="r3-inline-block md:r3-hidden">Elections</span>&ndash;&gt;-->
<!--      </div>-->
<!--    </div>-->
<!--  </button><button class = "flex-row r3-hidden md:r3-flex go_to_my_election" data-type="federal">-->
<!--    <img src = "/assets/ballotBoxFe.webp?v=1">-->
<!--    <div class = "left-text">-->
<!--      <div class = "num" id="federal_el_count"></div>-->
<!--      <div class = "light-gray election-label">Federal Positions</div>-->
<!--    </div>-->
<!--  </button>-->
<!--  <button class = "flex-row r3-hidden md:r3-flex go_to_my_election" data-type="state">-->
<!--    <img src = "/assets/ballotBoxSt.webp?v=1">-->
<!--    <div class = "left-text">-->
<!--      <div class = "num" id="state_el_count"></div>-->
<!--      <div class = "light-gray election-label">State Positions</div>-->
<!--    </div>-->
<!--  </button>-->
<!--  <button class = "flex-row r3-hidden md:r3-flex go_to_my_election" data-type="local">-->
<!--    <img src = "/assets/ballotBoxLo.webp?v=1">-->
<!--    <div class = "left-text">-->
<!--      <div class = "num" id="local_el_count"></div>-->
<!--      <div class = "light-gray election-label">Local Positions</div>-->
<!--    </div>-->
<!--  </button>-->
  <div class = "r3-flex go_to_my_election r3-justify-center r3-bg-button hover:r3-bg-button-hover r3-items-center r3-w-full r3-border r3-border-gray-300 r3-border-solid r3-cursor-pointer r3-rounded-lg r3-py-3 r3-px-4" data-type="all">
    <img class="r3-w-[40px] r3-mr-4" src="/assets/ballotBoxAe.webp?v=1">
    <p class="left-text r3-font-medium r3-text-lg" style="font-family: 'Libre Caslon Text', Helvetica,serif">
      All Elections
    </p>
  </div>
`

    // This is to make sure we don't conflict with other session-using features.
    static sessionVarPrefix = "ballotbox_";
    static sessionVars = [
        "zip",
        "state",
        "county",
        "city",
        "cityName",
        "abbr"
    ]

    constructor(div, state_abbr) {

        if (!state_abbr) {
            // Try pulling state abbreviation from session storage
            state_abbr = sessionStorage.getItem(BallotBoxPanel.sessionVarPrefix + "abbr");
            // console.log("Tried getting:", state_abbr, sessionStorage);
        }

        this.div = div;
        this.electionsOverview = null;

        // Put the template html in the passed-in div
        div.innerHTML = BallotBoxPanel.template;

        // Set the state ballot box image
        // const state_ballot_box = div.querySelector("button:nth-child(3) > img");
        // state_ballot_box.setAttribute( "src", "/assets/state_icons/" + state_abbr + ".PNG" );
        // state_ballot_box.setAttribute("src", "/assets/ballotBoxSt.webp");

        this.onLocalClick = null;
        this.onStateClick = null;
        this.onFederalClick = null;
    }

    // Set this if you want to include an elections overview link with the ballot boxes
    setElectionsOverviewDiv(div) {
        // this.electionsOverview = div;
    }

    // Clear storage to make sure we only have the relevant params in there.
    clearStorage() {
        this.clearSession();
    }

    // Stores ballot box parameters in a way that can be loaded from other pages with load()
    store(params) {
        this.clearStorage();
        this.writeToSession(params)
    }

    // Read ballot box params from persistent storage
    load() {
        return this.readFromSession();
    }

    // Stores location data in session storage in a format that can be decoded by readFromSession()
    // This allows persistance across multiple pages
    writeToSession(params) {
        for (var i = 0; i < BallotBoxPanel.sessionVars.length; i++) {
            const key = BallotBoxPanel.sessionVars [i];

            // Only store keys that are actually in params
            if (typeof params [key] === "undefined")
                continue;

            // Do the storage
            // This will throw an exception if the storage is full
            sessionStorage.setItem(BallotBoxPanel.sessionVarPrefix + key, params [key]);
        }
    }

    // Extract parameters from sessionStorage
    readFromSession() {
        const params = {};

        for (var i = 0; i < BallotBoxPanel.sessionVars.length; i++) {
            const key = BallotBoxPanel.sessionVars [i];
            const val = sessionStorage.getItem(BallotBoxPanel.sessionVarPrefix + key);

            // Only store values that are actually in session storage
            if (!val)
                continue;

            params [key] = val;
        }

        return params;
    }

    clearSession() {
        for (var i = 0; i < BallotBoxPanel.sessionVars.length; i++) {
            const key = BallotBoxPanel.sessionVars [i];
            sessionStorage.removeItem(BallotBoxPanel.sessionVarPrefix + key);
        }
    }

    // Convenience method
    loadAndUpdate() {
        this.update(this.load());
    }

    // Convenience method
    updateAndStore(params) {
        this.store(params);
        this.update(params);
    }

    // Update the ballot boxes on this page with a new location
    update(params) {

        const zip = params.zip;
        const state = api.format(params.state);
        const county = api.format(params.county);
        const city = api.format(params.city);
        const cityName = api.format(params.cityName);

        // TODO: Remove abbr and lookup abbr from state name (for all cases of abbreviation use)
        const abbr = params.abbr;

        const today = new Date();
        const oneYearFromToday = new Date(today.getTime() + 1 * 60 * 24 * 365 * 60000);

        // This url will be used to set button hrefs
        const url = new URL(window.location + "#");
        url.searchParams.set("type", "map-location-elections");
        // url.searchParams.set("start_date", api.format(today));
        // url.searchParams.set("end_date", api.format(oneYearFromToday));
        url.searchParams.set("state_abbr", abbr);

        //to skip API to get counts for federal and state level
        let count_is_given = 0;

        //Local box
        if (city) {
            // Update with local = city-level
            const countElement = this.div.querySelector("button:nth-child(3) .left-text .num");
            const button = this.div.querySelector("button:nth-child(3)");

            // Update button href & onclick
            const search_result_item_text = cityName + ", " + abbr;
            url.searchParams.set("search_result_item_text", search_result_item_text)
            url.searchParams.set("local", true);
            url.searchParams.set("city_id", city);

            button.addEventListener("click", () => {
                this.onLocalClick && this.onLocalClick();
            })

            // Update election count with api call
            const params = {
                start_date: today,
                end_date: oneYearFromToday,
                city_id: city,
            };
            api.get_election_counts_by_city(params).then(data => {
                this.div.querySelector(`button:nth-child(3) .left-text .num`).innerText = data.payload[1] ?? 0
                this.div.querySelector(`button:nth-child(2) .left-text .num`).innerText = data.payload[2] ?? 0
                this.div.querySelector(`button:nth-child(1) .left-text .num`).innerText = data.payload[3] ?? 0
            });
            count_is_given = 1;
        } else if (zip) {
            console.log("zip!");

            // Update with local =  zip-level
            const countElement = this.div.querySelector("button:nth-child(3) .left-text .num");
            const button = this.div.querySelector("button:nth-child(3)");

            // Update button href & onclick
            const search_result_item_text = zip;
            url.searchParams.set("search_result_item_text", search_result_item_text)
            url.searchParams.set("local", true);
            url.searchParams.set("zip_code", zip);

            // Update election count with api call
            const params = {
                start_date: today,
                end_date: oneYearFromToday,
                zip: zip,
            };


            this.div.querySelector(`button:nth-child(3) .left-text .num`).innerText = ""
            this.div.querySelector(`button:nth-child(2) .left-text .num`).innerText = ""
            this.div.querySelector(`button:nth-child(1) .left-text .num`).innerText = ""
            //
            //  api.get_election_counts_by_zip(params).then(data => {
            //     this.div.querySelector(`button:nth-child(3) .left-text .num`).innerText = data.payload[1]?? 0
            //     this.div.querySelector(`button:nth-child(2) .left-text .num`).innerText = data.payload[2]?? 0
            //     this.div.querySelector(`button:nth-child(1) .left-text .num`).innerText = data.payload[3]?? 0
            //
            // });
            count_is_given = 1;

        } else if (county) {
            // Update with local = county level
            // This api doesn't allow the use of county name
            // We need to look up the county ID by name first
            var counties;
            const params = {code: abbr};

            const search_result_item_text = county + " County, " + abbr;
            url.searchParams.set("search_result_item_text", search_result_item_text)
            url.searchParams.set("county_id", county);

            count_is_given = 1;
            api.get_counties_for_state_by_code(params).then(data => {
                const countyId = Object.keys(data.payload)[Object.values(data.payload).findIndex(value => value.name == county)];
                const button = this.div.querySelector("button:nth-child(3)");

                // Update button href & onclick
                url.searchParams.delete("local");
                url.searchParams.delete("state");
                url.searchParams.delete("federal");

                url.searchParams.set("local", true);
                url.searchParams.set("county_id", countyId);

                // Update election count
                const params = {
                    start_date: today,
                    end_date: oneYearFromToday,
                    county_id: countyId,
                };

                api.get_election_counts_by_county(params).then(data => {
                    //local candidates
                    console.log("ELECTIONS BY COUNTY", data.payload[1])
                    this.div.querySelector(`button:nth-child(3) .left-text .num`).innerHTML = data.payload[1] ?? ' '
                    this.div.querySelector(`button:nth-child(2) .left-text .num`).innerHTML = data.payload[2] ?? ' '
                    this.div.querySelector(`button:nth-child(1) .left-text .num`).innerHTML = data.payload[3] ?? ' '
                });
            });
        }

        console.log(url, county);

        // Update state ballot box button
        { // Scope block
            const button = this.div.querySelector("button:nth-child(2)");

            button.addEventListener("click", () => {
                this.onStateClick && this.onStateClick();
            })

            // Update button href & onclick
            url.searchParams.delete("local");
            url.searchParams.delete("state");
            url.searchParams.delete("federal");

            url.searchParams.set("state", true);
        }

        // Update federal ballot box button
        { // Scope block
            const button = this.div.querySelector("button:nth-child(1)");

            button.addEventListener("click", () => {
                this.onFederalClick && this.onFederalClick();
            })

            // Update button href & onclick
            url.searchParams.delete("local");
            url.searchParams.delete("state");
            url.searchParams.delete("federal");

            url.searchParams.set("federal", true);
        }

        { // Scope block for params
            if (!count_is_given) {
                const params = {
                    start_date: today,
                    end_date: oneYearFromToday,
                    state: state,
                    government_level_id: 2,
                };
                api.get_election_counts_by_state(params).then(data => {
                    const countElement = this.div.querySelector("button:nth-child(2) .left-text .num");
                    countElement.innerText = data.payload[state];
                });
            }
        }
        { // Scope block for params
            if (!count_is_given) {
                const params = {
                    start_date: today,
                    end_date: oneYearFromToday,
                    state: state,
                    government_level_id: 3,
                };
                api.get_election_counts_by_state(params).then(data => {
                    const countElement = this.div.querySelector("button:nth-child(1) .left-text .num");
                    countElement.innerText = data.payload[state];
                });
            }
        }

        // Update elections overview link
        if (this.electionsOverview) {
            const link = this.electionsOverview.querySelector("a");
            url.searchParams.delete("local");
            url.searchParams.delete("state");
            url.searchParams.delete("federal");
            // link.href = url;
        }
    }
}